function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_751",
  "data-name": "Rechteck 751",
  width: 42,
  height: 42,
  transform: "translate(0 0)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_maskieren_19",
  "data-name": "Gruppe maskieren 19",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "linkedin_3_",
  "data-name": "linkedin (3)",
  transform: "translate(0.094 0.094)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_15047",
  "data-name": "Pfad 15047",
  d: "M35.562,36.255v0h.01V20.884c0-7.519-1.619-13.31-10.408-13.31a9.125,9.125,0,0,0-8.219,4.517h-.122V8.276H8.489V36.253h8.678V22.4c0-3.648.691-7.175,5.209-7.175,4.451,0,4.517,4.163,4.517,7.409V36.255Z",
  transform: "translate(6.333 5.651)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_15048",
  "data-name": "Pfad 15048",
  d: "M.4,7.977H9.084V35.954H.4Z",
  transform: "translate(0.295 5.951)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Pfad_15049",
  "data-name": "Pfad 15049",
  d: "M5.032,0a5.056,5.056,0,1,0,5.032,5.032A5.034,5.034,0,0,0,5.032,0Z",
  fill: "#fff"
})));

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4d7b097f.svg";
export { ForwardRef as ReactComponent };